<ng-content select=[title]></ng-content>

<div class="git_info_block">
  <div class="task_commit_list" *ngFor="let commit of sortedTaskCommits">
    <a href={{commit.commitHtmlUrl}} target="_blank" rel="noopener">{{commit.commitComment}}</a>
    <span>by {{commit.authorLogin}}</span>
    <div class="edit_container" (click)=onRemove(commit)></div>
  </div>
</div>
